import React, { useState } from "react";
import { Outlet, useLocation, useParams } from "react-router-dom";
import Calendar from "../components/Calendar";
import Sidebar from "../components/Sidebar";
import styles from "./Homepage.module.css";
import MainMenu from "../menus/MainMenu";

function Homepage({ children }) {
  const theRoute = useLocation();
  const [calDate, SetCalDate] = useState(new Date());

  return (
    <main className={styles.main}>
      <Sidebar>
        <MainMenu />
      </Sidebar>

      <Outlet />
    </main>
  );
}

export default Homepage;
